import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  LOAD_WAY_BILL_BY_ID, LOAD_WAY_BILL,
} from '../actions';
import { WAY_BILL_MODULE } from '../../../configs/moduleNames';

import loadWayBillById from './loadWayBillById';
import loadWayBill from './loadWayBill';

export default function* watchSystem() {
  yield takeLatest(WAY_BILL_MODULE + LOAD_WAY_BILL_BY_ID, loadWayBillById);
  yield takeLatest(WAY_BILL_MODULE + LOAD_WAY_BILL, loadWayBill);
}
